export const messages = {
  en: {
    allocationStorehouseHistoryAuditOrders: {
      title: 'Allocation History Audit Orders',
      back: 'Back',
      refresh: 'Refresh',
      allocationNumber: 'Allocation Number',
      allocationCount: 'Allocation Count',
      applicant: 'Applicant',
      status: 'Status',
      time: 'Time',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch allocation history audit orders'
    }
  },
  zh: {
    allocationStorehouseHistoryAuditOrders: {
      title: '调拨已办单',
      back: '返回',
      refresh: '刷新',
      allocationNumber: '调拨编号',
      allocationCount: '调拨数量',
      applicant: '申请人',
      status: '状态',
      time: '时间',
      operation: '操作',
      detail: '详情',
fetchError: '获取调拨已办单失败'
    }
  },
  'zh-TW': {
    allocationStorehouseHistoryAuditOrders: {
      title: '調撥已辦單',
      back: '返回',
      refresh: '刷新',
      allocationNumber: '調撥編號',
      allocationCount: '調撥數量',
      applicant: '申請人',
      status: '狀態',
      time: '時間',
      operation: '操作',
      detail: '詳情',
      fetchError: '獲取調撥已辦單失敗'
    }
  }
}